import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../builder';
import { CTAClickTracking } from './CTAClickTracking';

export default createBuilderModule(withChildren(CTAClickTracking), {
  name: 'CTAClickTracking',
  image: 'https://cdn.zappy.app/d686bf40f1aa0706d104ed34eedb946b.png',
  description: 'DO NOT USE THIS ON ANY COMPONENTS WITH BUILT-IN CLICK TRACKING',
  inputs: [
    {
      name: 'sectionName',
      helperText:
        'DO NOT USE THIS ON ANY COMPONENTS WITH BUILT-IN CLICK TRACKING',
      type: 'string',
    },
  ],
});
